import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const ThreeColumnAdjustableContainer = (props) => {
  const {
      params,
      rendering
  } = props;
    var column1CSS = params["Column 1 Width"]
    var column2CSS = params["Column 2 Width"]
    var column3CSS = params["Column 3 Width"]

    return (
        <div class="container clearfix">
            <div className={column1CSS}>
                <Placeholder name="eti-column-one" rendering={rendering} />
            </div>
            <div className={column2CSS}>
                <Placeholder name="eti-column-two" rendering={rendering} />
            </div>
            <div className={column3CSS}>
                <Placeholder name="eti-column-three" rendering={rendering} />
            </div>
        </div> 
  );
};

export default ThreeColumnAdjustableContainer;
